// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_exn = require("rescript/lib/js/js_exn.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");

function enableCriteria(t) {
  return t.enableCriteria;
}

function limit(t) {
  return t.limit;
}

function defaultSettings(t) {
  return t.default;
}

function expandedSettings(t) {
  return t.expanded;
}

function type_(settings) {
  return settings.type_;
}

function size(settings) {
  return settings.size;
}

function initialFocus(settings) {
  return settings.initialFocus;
}

function decodeSettings(json) {
  var type_ = Json_decode.field("type", Json_decode.string, json);
  var initialFocus = Json_decode.field("initial_focus", Json_decode.string, json);
  var tmp;
  switch (type_) {
    case "all" :
        tmp = "All";
        break;
    case "custom" :
        tmp = "Custom";
        break;
    default:
      tmp = Js_exn.raiseError("Unknown type");
  }
  var tmp$1;
  switch (initialFocus) {
    case "first_window" :
        tmp$1 = "FirstWindow";
        break;
    case "last_window" :
        tmp$1 = "LastWindow";
        break;
    default:
      tmp$1 = Js_exn.raiseError("Unknown inital_focus");
  }
  return {
          type_: tmp,
          size: Json_decode.field("size", Json_decode.$$int, json),
          initialFocus: tmp$1
        };
}

function decode(json) {
  var enableCriteria = Json_decode.field("enable_criteria", Json_decode.string, json);
  var tmp;
  switch (enableCriteria) {
    case "limit_based" :
        tmp = "LimitBased";
        break;
    default:
      tmp = "Always";
  }
  return {
          enableCriteria: tmp,
          limit: Json_decode.field("limit", Json_decode.$$int, json),
          default: Json_decode.field("default", decodeSettings, json),
          expanded: Json_decode.field("expanded", decodeSettings, json)
        };
}

exports.enableCriteria = enableCriteria;
exports.limit = limit;
exports.defaultSettings = defaultSettings;
exports.expandedSettings = expandedSettings;
exports.type_ = type_;
exports.size = size;
exports.initialFocus = initialFocus;
exports.decode = decode;
/* No side effect */
